(function messagesScript($, Drupal) {
  Drupal.behaviors.social_share = {
    attach(context) {
      const $clipboardBtn = $('.js-clipboard-link', context);
      const currentUrl = $('.js-current-url').text();

      function copyToClipboard(value, showNotification, notificationText) {
        const $temp = $('<input>');
        $('body').append($temp);
        $temp.val(value).select();

        document.execCommand('copy');
        $temp.remove();

        if (typeof showNotification === 'undefined') {
          showNotification = true;
        }
        if (typeof notificationText === 'undefined') {
          notificationText = 'Copied to clipboard';
        }

        let notificationTag = $('div.social-share__notification');
        if (showNotification && notificationTag.length === 0) {
          notificationTag = $('<div/>', {
            class: 'social-share__notification',
            text: notificationText
          });
          $clipboardBtn.append(notificationTag);

          notificationTag.fadeIn('slow', () =>
            setTimeout(
              () =>
                notificationTag.fadeOut('slow', () => notificationTag.remove()),
              1000
            )
          );
        }
      }

      $clipboardBtn.click(function activateClipboard(event) {
        event.preventDefault();
        copyToClipboard(currentUrl, true, Drupal.t('Copied to clipboard'));
        Drupal.announce(Drupal.t('Copied to clipboard'));
      });
    }
  };
}(jQuery, Drupal));
